import React from 'react';
import ReactDOM from 'react-dom';
import { Provider, } from 'react-redux';
import { ThemeProvider, } from './legacy-tv-ui';
import { Cookies, } from 'react-cookie';

import store from './store';
import Router from './router';
import * as types from './constant/actionTypes';

const cookies = new Cookies();
const token = cookies.get('_t');
const company = cookies.get('_c');
if (token) {
  store.dispatch({
    type: types.AUTH_USER,
    payload: { token, company, },
  });
}

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider>
      <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN" crossOrigin="anonymous" />
      <Router />
    </ThemeProvider>
  </Provider>
  ,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js